import { Typography } from '@mui/material';
import React from 'react'
import WebhookIcon from '@mui/icons-material/Webhook';
import CloudCircleIcon from '@mui/icons-material/CloudCircle';
import TableRowsIcon from '@mui/icons-material/TableRows';

function PolicyComponents() {

    const onDragStart = (event, nodeType) => {
        event.dataTransfer.setData('application/reactflow', nodeType);
        event.dataTransfer.effectAllowed = 'move';
    };

    return (
        <div className='flex flex-1 flex-col gap-3'>
            <div
                className='border rounded-[5px] p-3 flex flex-row justify-start items-center w-full cursor-pointer hover:border-blue-500'
                onDragStart={(event) => onDragStart(event, 'application')}
                draggable
            >
                <WebhookIcon className='mr-3' color="primary" sx={{ fontSize: 30 }} />
                <Typography variant="subtitle2">Application</Typography>
            </div>
            <div
                className='border rounded-[5px] p-3 flex flex-row justify-start items-center w-full cursor-pointer hover:border-blue-500'
                onDragStart={(event) => onDragStart(event, 'restfulapi')}
                draggable
            >
                <CloudCircleIcon className='mr-3' color="primary" sx={{ fontSize: 30 }} />
                <Typography variant="subtitle2">RESTful API</Typography>
            </div>
            <div
                className='border rounded-[5px] p-3 flex flex-row justify-start items-center w-full cursor-pointer hover:border-blue-500'
                onDragStart={(event) => onDragStart(event, 'data')}
                draggable
            >
                <TableRowsIcon className='mr-3' color="primary" sx={{ fontSize: 30 }} />
                <Typography variant="subtitle2">Data</Typography>
            </div>
        </div>
    )
}

export default PolicyComponents